import type { StateCreator } from 'zustand';

import { HOME_FEED_SLUG, type HomeTabsSlice } from './types';

export type { HomeTabsSlice } from './types';

export const homeTabsInitialState = {
  activeHomeTab: HOME_FEED_SLUG,
  hideHomeTabs: false,
};

export const createHomeTabsSlice: StateCreator<
  HomeTabsSlice,
  [],
  [],
  HomeTabsSlice
> = (set) => ({
  ...homeTabsInitialState,
  setActiveHomeTab: (activeHomeTab) => set({ activeHomeTab }),
});
